/**
 * (c) 2021-2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { PythonModule } from "./model";
import { baseUrl } from "../../base";

export const fetchMappingData = async (): Promise<ApiReferenceMap> => {
  const response = await fetch(
    `${baseUrl}content/reference/api-reference-modules.json`
  );
  if (!response.ok) {
    throw new Error(`Error fetching local API mapping: ${response.status}`);
  }
  const content = adaptContent(await response.json());
  if (!content) {
    throw new Error("Bundled API reference mapping must exist");
  }
  return content;
};

export type ApiReferenceMap = Record<
  string,
  Record<string, ReferenceLinkDetail>
>;

export interface ReferenceLinkDetail {
  referenceLink: string;
  alternative?: string;
}

const adaptContent = (result: any): ApiReferenceMap | undefined => {
  const mappingData = result as PythonModule[];
  if (!Array.isArray(mappingData)) {
    return undefined;
  }
  // Leer ist gueltig: die Zuordnung verweist von der API-Hilfe auf
  // micro:bit-Referenzthemen, und die gehoeren nicht mehr zum Build.
  const map: ApiReferenceMap = {};
  for (const module of mappingData) {
    for (const moduleItem of module.pythonModuleItem) {
      const referenceLink = moduleItem.referenceLink?.slug?.current;
      const alternative = moduleItem.pythonAlternativeContentLink;
      if (referenceLink) {
        map[module.pythonModuleName] = {
          ...map[module.pythonModuleName],
          [moduleItem.pythonApiEntry]: {
            referenceLink,
            alternative,
          },
        };
      }
    }
  }
  return map;
};
